import * as polished from 'polished';
import styled from 'styled-components';

type MarkerProps = {
  color: string;
};

export const MatchMarker = styled.div<MarkerProps>`
  position: relative;
  width: 36px;
  height: 36px;
  line-height: 36px;
  border-radius: 50%;
  background: ${(p: MarkerProps) => p.color};
  border: 2px solid ${(p: MarkerProps) => polished.lighten(0.2, p.color)};

  > svg {
    //top: 0.125rem;
  }

  > svg * {
    fill: white;
  }

  &:before {
    content: '';
    display: block;
    position: absolute;
    bottom: -5px;
    height: 5px;
    width: 3px;
    background: ${(p: MarkerProps) => p.color};
    left: 50%;
    margin-left: -2px;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
  }
`;

export const DiarizationMarkerLabel = styled.div<MarkerProps>`
  /* border-box keeps outer size stable (36px) so StreamEl bottom anchoring does not jump. */
  box-sizing: border-box;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  /* Avoid line-box/baseline shifts when Avatar content swaps (icon → img/initials). */
  line-height: 0;
  border-radius: 50%;
  background: ${(p: MarkerProps) => p.color};
  border: 2px solid ${(p: MarkerProps) => p.color};

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: -5px;
    height: 5px;
    width: 3px;
    background: ${(p: MarkerProps) => p.color};
    left: 15px;
    border-top-right-radius: 50%;
    border-top-left-radius: 50%;
  }
`;
